import React, { useContext, useState, useEffect } from 'react'
import { PlayerProfileContext } from '../../../../Context'
import { ProfileImage, CountryFlag } from '../../../../Components/PersonStatsCard'
import { Favorite } from '../../../../Components/Favorite'
import { Links } from './Links'
import { createUrl } from '../../../../Routing/urls'
import { Injury } from '../Injury/Injury'
import { PlayerDataGQL } from '../../../../Api'
import { LinkBarCon, TeamCon } from './styles'
import { getTeamLocation } from '../../../../Utils'
import { Lk } from '../../../../Components/Links/Lk'

type NavLink = {
  to: string
  active: boolean
  label: string
}

export const PlayerLinkBar: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, team, params, media, urls } = useContext(PlayerProfileContext)!
  const teamName = team?.fullName
  const [navLinks, setNavLinks] = useState<NavLink[]>([])

  useEffect(() => {
    if (!player || !urls) return
    let playerLinks = [
      {
        to: urls.playerProfile(),
        active: params?.tab === 'profile',
        label: 'Profile',
      },
      {
        to: urls.playerStats(),
        active: params?.tab === 'stats',
        label: 'Stats',
      },
    ]
    if (media.length > 0 || player?.twitterUrl) {
      //Add media tab if there is media
      playerLinks.push({
        to: urls?.playerMedia(),
        active: params?.tab === 'media',
        label: 'Media',
      })
    }

    setNavLinks(playerLinks)
  }, [player, media])

  const renderName = (player: PlayerDataGQL) => {
    return `${player.firstName} ${player.lastName}${
      player.lastNameSuffix ? ` ${player.lastNameSuffix}` : ''
    }`
  }

  return (
    <>
      {player && (
        <LinkBarCon>
          <div className="up">
            <div className="photo">
              <ProfileImage img={player.profileUrl} />
            </div>
            <div className="nameCon">
              <div className="name">{renderName(player)}</div>
              <TeamCon>
                {player.currentTeam && (
                  <div className="team">
                    <p>
                      {player?.currentTeam?.jerseyNum !== null
                        ? `${player.currentTeam.jerseyNum} | `
                        : ''}
                    </p>
                    <Lk
                      link={createUrl('teams', { id: teamName })}
                      classNameObj="teamLink"
                      alt={`${getTeamLocation(
                        player.currentTeam.officialId
                      )} ${teamName}`}
                    >
                      <p className="teamLink">
                        {`${getTeamLocation(player.currentTeam.officialId)} ${teamName}`}
                      </p>
                    </Lk>
                  </div>
                )}
                <CountryFlag countryCode={player.countryCode} />
                <Injury player={player} />
              </TeamCon>
            </div>
            <Favorite
              className="favMargin"
              size="large"
              name={player.slug}
              favType="favPlayers"
              player={player}
            />
          </div>
          <Links
            className="socials"
            color={team?.teamColor}
            socials={{
              twitter: player.twitterUrl,
              instagram: player.instagramUrl,
            }}
            navs={navLinks}
          />
        </LinkBarCon>
      )}
    </>
  )
}
